<!--#region Modals-->
@if(isSetupModalOpen){
<app-device-setup (closeSignal)="closeWindow()" [deviceNumber]="selectedRow?.id!"
    [row]="selectedRow"></app-device-setup>
}
@if(isFirmwareUpdateModalOpen){
<app-firmware-update-modal (closeSignal)="closeFwUpdateModal()" [metersIdsInput]="selectedRows"
    [selectedMeters]="selectedMeterData" (meterDeselected)="deselectMeterById($event)">
</app-firmware-update-modal>
}
@if(isFirmwareUpdateProgressModalOpen){
<app-firmware-update (closeSignal)="closeFirmwareUpdateProgressModal()"
    [firmwareStatus]="selectedRow?.firmwareUpdateStatus"></app-firmware-update>
}

<!--OVDE TABELA-->
<!--#endregion-->
<div class="subpage-container">
    <div class="container g-0 m-0">
        <!--#region Table options-->
        <div class="row d-flex align-items-center g-0 m-0 p-0 mb-2">
            <div class="col-8 d-flex justify-content-start align-items-center flex-nowrap ps-4 pb-2 gap-3">
                <app-device-management-filter class="flex-shrink-0" [numberOfResults]="numberOfDevices"
                    [selectedMeterMakes]="selectedFilters.meterMakes"
                    [selectedMeterModels]="selectedFilters.meterModels || []"
                    [selectedAssetTypes]="selectedFilters.assetTypes"
                    [selectedStatuses]="selectedFilters.configurationStatuses || []"
                    [selectedServiceTypes]="selectedFilters.serviceTypes" [onlineStatus]="selectedFilters.onlineStatus"
                    [simStatus]="selectedFilters.simStatus"
                    [lastCommunication]="selectedFilters.lastCommunication"
                    [selectedAreas]="selectedFilters.areas || []" [selectedRegions]="selectedFilters.regions || []"
                    (applied)="onDataReceived($event)">
                </app-device-management-filter>
                <app-sort class="flex-shrink-0" (close)="onSortOption($event)"></app-sort>
                <!--#region Datepicker-->
                <div class="datepicker-container-wrapper position-relative flex-shrink-0">
                    <div class="button-wrapper">
                        <div class="button">
                            <img alt="Date" src="assets/core/table-button/date.svg" />
                            <div class="button-text" (click)="toggleModal()"
                                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                                    {{ selectedDate }}
                                </ng-container>
                                <ng-template #noDateSelected>
                                    <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                                </ng-template>
                            </div>
                            <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit"
                                src="assets/device/x.svg" (click)="clearDates()" />
                        </div>
                    </div>
                    @if (isDatepickerOpen) {
                    <div class="overlay" (click)="toggleModal()"></div>
                    <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                        [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
                    }
                </div>
                <!--#endregion-->
                <app-search placeholder="{{ 'DEVICES_SEARCHBY' | translate }}"
                    (searchChange)="searchChange($event)" class="d-flex flex-shrink-0"></app-search>
            </div>
            <div class="col-4 d-flex align-items-center justify-content-end pe-3 gap-2">
                <!-- FHD only: selected + ikone u istom redu sa show-hide -->
                <div *ngIf="selectedRows.length > 0" class="d-none d-xxl-flex align-items-center gap-2">
                    <span class="custom-color d-flex align-items-center gap-2">
                        {{selectedRows.length}} Selected
                        <img alt="Clear" src="assets/device/x.svg" (click)="clearSelection()" title="Clear selection" />
                    </span>
                    <div *ngIf="authService.isAuthorized([PermissionsEnum.Device_firmware_update])"
                        class="button-wrapper-gray ">
                        <div class="button" [class.disabled]="selectedMeterModels.length !== 1"
                            [attr.title]="selectedMeterModels.length === 1 ? ('FIRMWARE_UPDATE' | translate) : 'You can only update meters of the same model'"
                            (click)="selectedMeterModels.length === 1 && (isFirmwareUpdateModalOpen = true)">
                            <img class="p-0" alt="Firmware Update" src="assets/device/firmware-update.svg" />
                        </div>
                    </div>
                    <div *ngIf="authService.isAuthorized([PermissionsEnum.Device_bulk_delete])"
                        class="button-wrapper-gray">
                        <div class="button" (click)="isBulkDeleteModalOpen = true" title="Bulk delete">
                            <img class="p-0" alt="Delete" src="assets/core/table/delete.svg" />
                        </div>
                    </div>
                    <div *ngIf="authService.isAuthorized([PermissionsEnum.Device_bulk_configure])"
                        class="button-wrapper-gray">
                        <div class="button" (click)="isBulkSetupOptionModalOpen = true" title="Bulk reconfiguration">
                            <img class="p-0" alt="Reconfig" src="assets/device/reconfig.svg" />
                        </div>
                    </div>
                </div>
                <app-show-hide-columns class="flex-shrink-0"
                    [columns]="columns" [selectedColumns]="selectedColumns"
                    (columnsChange)="updateColumns($event)"></app-show-hide-columns>
            </div>
        </div>

        <!-- HD only: selected + ikone u posebnom redu ispod -->
        <div *ngIf="selectedRows.length > 0" class="row d-xxl-none g-0 m-0 ps-5 mb-2 d-flex align-items-center gap-2">
            <span class="col-auto custom-color d-flex align-items-center gap-2">
                {{selectedRows.length}} Selected
                <img alt="Clear" src="assets/device/x.svg" (click)="clearSelection()" title="Clear selection" />
            </span>
            <div *ngIf="authService.isAuthorized([PermissionsEnum.Device_firmware_update])"
                class="col-auto button-wrapper-gray">
                <div class="button" [class.disabled]="selectedMeterModels.length !== 1"
                    [attr.title]="selectedMeterModels.length === 1 ? ('FIRMWARE_UPDATE' | translate) : 'You can only update meters of the same model'"
                    (click)="selectedMeterModels.length === 1 && (isFirmwareUpdateModalOpen = true)">
                    <img class="p-0" alt="Firmware Update" src="assets/device/firmware-update.svg" />
                </div>
            </div>
            <div *ngIf="authService.isAuthorized([PermissionsEnum.Device_bulk_delete])"
                class="col-auto button-wrapper-gray">
                <div class="button" (click)="isBulkDeleteModalOpen = true" title="Bulk delete">
                    <img class="p-0" alt="Delete" src="assets/core/table/delete.svg" />
                </div>
            </div>
            <div *ngIf="authService.isAuthorized([PermissionsEnum.Device_bulk_configure])"
                class="col-auto button-wrapper-gray">
                <div class="button" (click)="isBulkSetupOptionModalOpen = true" title="Bulk reconfiguration">
                    <img class="p-0" alt="Reconfig" src="assets/device/reconfig.svg" />
                </div>
            </div>
        </div>
        <!--#endregion-->
        <!--#region Table-->
        <div class="row g-0 m-0 table-scroll">
            <table>
                <thead>
                    <th></th>
                    <th class="ps-1">
                        <input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelected($event)"
                            (click)="$event.stopPropagation()" class="form-check-input custom-checkbox" />
                    </th>
                    <ng-container *ngFor="let col of displayedColumns">
                        <th [ngClass]="{'fixed-col': col.fixPosition===true,
                            'data-col': col.fixPosition !== true}">
                            <div>
                                @if(!col.fixPosition){
                                <img src="assets/device/column-menu.svg" />
                                <span>{{ col.header | translate }}</span>
                                }
                            </div>
                        </th>
                    </ng-container>
                    <th></th>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i = index;" (click)="handleRowClick(row)">
                        <td appIsNew [executedTime]="row.meterInstallationDate!"></td>
                        <td class="ps-1" (click)="checkbox.click(); $event.stopPropagation()">
                            <input type="checkbox" [checked]="isRowSelected(row.id!)" [id]="'checkbox-' + row.id"
                                (change)="toggleRowSelection(row)" (click)="$event.stopPropagation()"
                                class="form-check-input custom-checkbox" #checkbox />
                        </td>
                        <ng-container *ngFor="let col of displayedColumns">
                            <td [ngSwitch]="col.key" [class.status-cell]="col.key === 'status'"
                                [class.data-col]="col.fixPosition !== true">
                                <span *ngSwitchCase="'meterNo'"
                                    (click)="clipboardService.copyToClipboardDeviceManagement(row.meterNo!, $event, 'meterNo-' + i)"
                                    class="copyable" title="{{row.meterNo}}">
                                    {{ row.meterNo }}
                                    <span class="copy-tooltip" *ngIf="clipboardService.copiedId === 'meterNo-'+i">
                                        {{
                                        "COPIED" |
                                        translate
                                        }}
                                    </span>
                                </span>
                                <span *ngSwitchCase="'meterIp'"
                                    (click)="clipboardService.copyToClipboardDeviceManagement(row.meterIp!, $event, 'meterIp-' + i)"
                                    class="copyable" title="{{row.meterIp}}">
                                    {{ row.meterIp }}
                                    <span class="copy-tooltip" *ngIf="clipboardService.copiedId === 'meterIp-'+i">
                                        {{
                                        "COPIED" |
                                        translate
                                        }}
                                    </span>
                                </span>
                                <span *ngSwitchCase="'meterPort'"
                                    (click)="clipboardService.copyToClipboardDeviceManagement(row.meterPort.toString()!, $event, 'meterPort-' + i)"
                                    class="copyable" title="{{row.meterPort}}">
                                    {{ row.meterPort }}
                                    <span class="copy-tooltip" *ngIf="clipboardService.copiedId === 'meterPort-'+i">
                                        {{
                                        "COPIED" |
                                        translate
                                        }}
                                    </span>
                                </span>
                                <span *ngSwitchCase="'meterInstallationDate'" title="{{row.meterInstallationDate}}">
                                    {{ row.meterInstallationDate | date: "dd MMM yyyy" }}
                                </span>
                                <span *ngSwitchCase="'lastOnlineTime'">
                                    <span class="d-inline-flex align-items-center gap-1">
                                        <span>
                                            {{ row.lastOnlineTime ? (row.lastOnlineTime | date:'dd MMM yyyy, h:mm a') : '/' }}
                                        </span>
                                        <img *ngIf="getCommunicationWarning(row) as warning" class="resize-img"
                                            src="assets/settings/yellow-exclamation.svg"
                                            [title]="warning" alt="" />
                                    </span>
                                </span>
                                <ng-container *ngSwitchCase="'configurationStatus'">
                                    <img *ngIf="getConfigurationStatusImage(row) as imgSrc" class="pb-0 resize-configuration" [src]="imgSrc"
                                        [title]="getImageTooltip(row.configurationStatus)"
                                        (click)="handleSetup(row); $event.stopPropagation()" />
                                </ng-container>
                                <!-- <ng-container *ngSwitchCase="'lowLevelPwdChangeStatus'">
                                    <img *ngIf="getLowLevelPwdChangeImage(row) as pwdImgSrc" class="pb-0"
                                        alt="Password change" [src]="pwdImgSrc"
                                        [class.cursor-pointer]="isPwdChangeRetryable(row.lowLevelPwdChangeStatus)"
                                        [title]="getLowLevelPwdChangeTooltip(row.lowLevelPwdChangeStatus)"
                                        (click)="isPwdChangeRetryable(row.lowLevelPwdChangeStatus) && retryPasswordChangeTrigger(row); $event.stopPropagation()" />
                                </ng-container> -->
                                <span *ngSwitchCase="'status'" class="tooltip-wrap"
                                    (mouseenter)="positionStatusTooltip($event)">
                                    <img class="resize-img"
                                        [src]="row.status ? 'assets/device/online-dot.svg' : 'assets/device/offline-dot.svg'"
                                        alt="" />
                                    <span class="tooltip-panel">
                                        <span>
                                            {{'SIMSTATUS' | translate}}: <span
                                                [style.color]="row.simRegistered ? 'green' : 'red'">
                                                {{ row.simRegistered ? ('ONLINE' | translate) : ('OFFLINE' | translate) }}
                                            </span><br>
                                        </span>
                                        <span>
                                            {{'COMMUNICATIONSTATUS' | translate}}: <span
                                                [style.color]="hasRecentCommunication(row) ? 'green' : 'red'">
                                                {{ hasRecentCommunication(row) ? ('ONLINE' | translate) : ('OFFLINE' | translate) }}
                                            </span><br>
                                        </span>
                                        <span>
                                            {{'DEVICESETUP_GSMIPSECCONNECTOR' | translate}}: <span
                                                [style.color]="row?.ipSecConnector ? 'green' : 'red'">
                                                <img class="pb-0"
                                                    [src]="row.ipSecConnector ? 'assets/device/ipsec-connect-on.svg' : 'assets/device/ipsec-connect-off.svg'"
                                                    [title]="row.ipSecConnector ? row.ipSecConnector : ('DEVICESETUP_NOIPSEC' | translate) ">
                                            </span>
                                        </span><br>
                                        <span>
                                            {{"NOFAILEDCMDS" | translate}}: <span
                                                [style.color]="row?.communicationFailCount == 0 ? 'green' : 'red'">
                                                {{
                                                row?.communicationFailCount == null
                                                ? '/'
                                                : row.communicationFailCount
                                                }}
                                            </span>
                                        </span><br>
                                        <span class="d-flex flex-row">
                                            {{"LASTREADTIME" | translate}}:
                                            <div class="d-flex flex-column align-items-center">
                                                @if(row.lastReadTime){
                                                <app-timer-component [interval]="row.dataCollectionIntervals!"
                                                    [lastReadTime]="row.lastReadTime!"></app-timer-component>
                                                }
                                                @else{
                                                <span class="text-danger">
                                                    {{'NOREADS' | translate}}
                                                </span>
                                                }
                                                {{row.lastReadTime | date: "dd MMM yyyy, h:mm a"}}
                                            </div>
                                        </span>

                                        <span>
                                            {{"LASTEVENTTIME" | translate}}:
                                            {{ row.lastEventTime ? (row.lastEventTime | date: "dd MMM yyyy, h:mm a") : '/' }}
                                        </span><br>
                                        <span>
                                            {{"LASTALARMTIME" | translate}}:
                                            {{ row.lastAlarmTime ? (row.lastAlarmTime | date: "dd MMM yyyy, h:mm a") : '/' }}
                                        </span>
                                    </span>
                                </span>
                                <ng-container *ngSwitchCase="'locationChanged'">
                                    <span *ngIf="row.locationChanged" title="{{ 'LOCATION_CHANGED' | translate }}">
                                        <img class="pb-0" src="assets/device/location-change.svg">
                                    </span>
                                </ng-container>
                                <span *ngSwitchCase="'isConnected'">
                                    <img class="pb-0"
                                        [src]="row.isConnected ? 'assets/device/connect.svg' : 'assets/device/disconnect.svg'"
                                        [title]="row.isConnected ? 'Connected' : 'Disconnected'">
                                </span>
                                <ng-container *ngSwitchCase="'firmwareUpdateStatus'">
                                    <img *ngIf="getFirmwareUpdateImage(row) as imgSrc" class="p-0" alt="Firmware Update"
                                        [src]="imgSrc" [title]="getFwUpdateImageTooltip(row.firmwareUpdateStatus)"
                                        (click)="openFirmwareUpdateProgress(row); $event.stopPropagation()">
                                </ng-container>
                                <ng-container *ngSwitchCase="'meterModel'">
                                    <span class="d-inline-flex align-items-center gap-1">
                                        <span title="{{ row.meterModel }} ({{row.meterFirmware}})">{{ row.meterModel }}</span>
                                        <span *ngIf="row.nextVersion" class="tooltip-wrap"
                                            (mouseenter)="positionStatusTooltip($event)">
                                            <img class="resize-img" src="assets/settings/yellow-exclamation.svg" alt=""
                                                (click)="$event.stopPropagation()" />
                                            <span class="tooltip-panel next-setup-panel">
                                                <span class="next-setup-title">
                                                    {{ 'NEXT_SETUP' | translate }}
                                                </span>
                                                <span class="next-setup-row">
                                                    <span class="next-setup-label">{{ 'DEVICESETUP_METERMODEL' | translate }}</span>
                                                    <span class="next-setup-value">{{ row.nextMeterModel }}</span>
                                                </span>
                                                <span class="next-setup-row">
                                                    <span class="next-setup-label">{{ 'DEVICESETUP_FIRMWAREVERSION' | translate }}</span>
                                                    <span class="next-setup-value">{{ row.nextMeterFirmware }}</span>
                                                </span>
                                                <span class="next-setup-row">
                                                    <span class="next-setup-label">{{ 'VERSION' | translate }}</span>
                                                    <span class="next-setup-value">v{{ row.nextVersion }}</span>
                                                </span>
                                            </span>
                                        </span>
                                    </span>
                                </ng-container>
                                <span *ngSwitchDefault title="{{row[col.key]}}">
                                    {{ row[col.key] }}
                                </span>
                            </td>
                        </ng-container>
                        <td>
                            @if (authService.isAuthorized([PermissionsEnum.Device_delete])) {
                            <img class="p-0" alt="Delete" src="assets/core/table/delete.svg"
                                (click)="handleDelete(row)" />
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!--#endregion-->
    </div>
</div>

<!-- #region Confirmation Modals-->
<app-confirm-dialog *ngIf="isDeleteModalOpen" titleKey="DELETE" question="DEVICES_DELETE"
    (confirm)="confirmDelete(selectedRow!)" (cancel)="cancelDelete()"></app-confirm-dialog>

<app-confirm-dialog *ngIf="isBulkDeleteModalOpen" titleKey="BULK_DELETE" question="DEVICES_BULKDELETE"
    (confirm)="confirmBulkDelete()" (cancel)="isBulkDeleteModalOpen = false"></app-confirm-dialog>

<app-confirm-dialog *ngIf="isBulkSetupModalOpen" titleKey="SETUP"
    [question]="isForceFullBulkSetup ? 'FORCE_FULL_SETUP_QUESTION' : 'PARTIAL_SETUP_QUESTION'"
    (confirm)="bulkSetup()" (cancel)="isBulkSetupModalOpen = false"></app-confirm-dialog>

<app-setup-option-dialog *ngIf="isBulkSetupOptionModalOpen"
    (optionSelected)="isBulkSetupModalOpen = true; isBulkSetupOptionModalOpen = false; isForceFullBulkSetup = $event"
    (cancel)="isBulkSetupOptionModalOpen = false"></app-setup-option-dialog>

<!-- #endregion -->
<!--#region Pagination-->
<div class="container-down">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfDevices" [pageSize]="pageSize"
        [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
</div>
<!-- #endregion -->
<router-outlet></router-outlet>